<template>
  <div class="container-html">
    <div class="sc-message--text" :style="messageColors">
      <p class="sc-message--text-content" v-html="messageText"></p>
      <p v-if="message.data.meta" class='sc-message--meta' :style="{color: messageColors.color}">{{message.data.meta}}</p>
    </div>
  </div>
</template>

<script>
import escapeGoat from 'escape-goat'
import store from "./../store/"

export default {
  data() {
    return {
      store
    }
  },
  props: {
    message:{
      type: Object,
      required: true
    },
    messageColors: {
      type: Object,
      required: true
    },
    messageStyling: {
      type: Boolean,
      required: true
    },
    chatbotColors: {
      type: Object,
      required: true
    },
    lastMessage: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    messageText() {
      const escaped = this.me
        ? escapeGoat.escape(this.message.data.text)
        : this.message.data.text;

      return escaped;
    },
    me(){
      return this.message.author === 'me';
    }
  }
}
</script>

<style scoped>
.sc-message--text {
  margin-right: 0 !important;
}
.sc-message--text-content {
  -webkit-perspective: 0px !important;
  -webkit-backface-visibility: visible !important;
  -webkit-transform: translate3d(0,0,0) !important;
}
a.chatLink {
  color: inherit !important;
}
</style>
